import "./InputFormContainer.scss";

const InputFormContainer = ({
  label,
  indentificador,
  children,
  spanTwo,
  customClass
}) => {
  return (
    <div className={`input-form ${spanTwo && "m-cols-2"} ${customClass}`}>
      <label htmlFor={indentificador} className="source-16 mb-15">
        {label}
      </label>
      {children}
    </div>
  );
};

export default InputFormContainer;
